"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SchemaBuilder;
const zod_1 = require("zod");
function SchemaBuilder(schemaFields) {
    const SchemaObject = {};
    schemaFields.forEach((field) => {
        SchemaObject[field.name] = field.validation;
    });
    return zod_1.z.object(SchemaObject);
}
//# sourceMappingURL=SchemaBuilder.js.map